import { useNavigate } from "react-router-dom";
import { CustomList, CustomPageHeader } from "../../ui";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../contexts";
import { CustomTag } from "../../ui";
import axios from "axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../assets/constants";
import { PlusIcon, UsersIcon } from "@phosphor-icons/react";

const UserList = () => {
    const { token } = useContext(AuthContext);
    const navigate = useNavigate();
    const [selectedColumns, setSelectedColumns] = useState(0);
    const [selectedIds, setSelectedIds] = useState([]);
    const [refreshCounter, setRefreshCounter] = useState(0);

    const columns = React.useMemo(
        () => [
            {
                Header: "Prénom",
                accessor: "firstName",
                icon: "user",
                Cell: ({ cell: { value } }) => <span>{value}</span>,
            },
            {
                Header: "Nom",
                accessor: "lastName",
                icon: "user",
                Cell: ({ cell: { value } }) => <span>{value}</span>,
            },
            {
                Header: "Email",
                accessor: "email",
                icon: "email",
                Cell: ({ cell: { value } }) => <span>{value}</span>,
            },
            {
                Header: "Rôle",
                accessor: "role.name",
                icon: "tag-simple",
                Cell: ({ cell: { value } }) => <CustomTag value={value} />,
            },
            {
                Header: "Congés",
                accessor: "holidayActive",
                icon: "tag-simple",
                Cell: ({ cell: { value } }) => <CustomTag value={value ? "Oui" : "Non"} className={value ? "active" : "inactive"} />,
            },
            {
                Header: "Actif",
                accessor: "isActive",
                icon: "tag-simple",
                Cell: ({ cell: { value } }) => <CustomTag value={value ? "Oui" : "Non"} className={value ? "active" : "inactive"} />,
            },
        ],
        []
    );

    const handleBulkDelete = () => {
        if (window.confirm("Attention : vous êtes sur le point de supprimer plusieurs utilisateurs")) {
            axios
                .post(process.env.REACT_APP_UPA_API_HOST + "users/bulk-delete", { selectedIds }, { headers: { Authorization: "Bearer " + token } })
                .then(() => {
                    toast.success("Utilisateurs supprimés", toastOptions);
                    setRefreshCounter(refreshCounter + 1);
                })
                .catch((err) => {
                    toast.error(err.response.data.message, toastOptions);
                });
        }
    };
    return (
        <div className="c-app__view">
            <CustomPageHeader 
                title="Utilisateurs"
                titleIcon={{ icon: UsersIcon }}
                buttons={selectedColumns === 0 ? [
                    {
                        label: "Ajouter un utilisateur",
                        onClick: () => navigate("new"),
                        icon: PlusIcon,
                        variant: "primary"
                    }
                ] : [
                    {
                        label: "Supprimer",
                        onClick: handleBulkDelete,
                        variant: "danger"
                    }
                ]}
            />
            <div className="tabs-container">
                <CustomList
                    entity="users"
                    refreshData={refreshCounter}
                    columns={columns}
                    setSelectedColumns={setSelectedColumns}
                    setSelectedIds={setSelectedIds}
                />
            </div>
        </div>
    );
};

export default UserList;
